import { useState } from 'react';
import { Box, Button, ButtonProps } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import { format, parseISO } from 'date-fns';
import { getDateLocale } from '../../lib/dateLocale';
import { SttCalendarDialog } from '../all';

type SttButtonDateProps = {
    date: string;
    onSelectDate: (date: string) => void;
} & ButtonProps;

/**
 * Button date
 */
export function SttButtonDate({
    date,
    onSelectDate,
    ...rest
}: SttButtonDateProps) {
    const [calendarOpen, setCalendarOpen] = useState(false);

    /**
     * Select date
     */
    const selectDate = (selectedDate: string) => {
        onSelectDate(selectedDate);
        setCalendarOpen(false);
    };

    return (
        <>
            <Button
                {...rest}
                variant="outlined"
                onClick={() => setCalendarOpen(true)}
            >
                <TodayIcon />
                {date && (
                    <Box ml={1}>
                        {format(parseISO(date), 'd-MM-yyyy', {
                            locale: getDateLocale(),
                        })}
                    </Box>
                )}
            </Button>

            <SttCalendarDialog
                open={calendarOpen}
                date={date}
                onSelectDate={selectDate}
                onClose={() => setCalendarOpen(false)}
            />
        </>
    );
}
